app.factory('gameService', ['$q', '$timeout', '$http', function ($q, $timeout, $http, teacherAppService) {
	var service = this;

	service.restart = function() {
		service.startTime = new Date();
		service.teamName = undefined;
		service.teamImageURL = undefined;
		service.teamMembers = [];
		service.config = {};
		service.rides = [];
		service.exercises = [];
		service.gameState = {
			finishedWelcome: false,
			exerciseIndex: 0,
			questionIndex: 0,
			evaluationQuestionIndex: 0,
			score: 0,
			evaluationAnswers: {}
		};
	}

	service.ready = false;
	service.isTeacher= false;
	service.startTime = new Date();
	service.teamName = undefined;
	service.teamImageURL = undefined;
	service.teamMembers = [];
	service.config = {};
	service.rides = [];
	service.exercises = [];
	service.gameState = {
		finishedWelcome: false,
		exerciseIndex: 0,
		questionIndex: 0,
		evaluationQuestionIndex: 0,
		score: 0
	};

	service.titleCaseTeamName = function(name) {
       	var out = "";

       	if (name === undefined) {
       		return undefined;
       	}

        var doUpper = true;
        for (var i = 0; i < name.length; i++) {
            var ch = name[i];
            if (doUpper) {
                out += ch.toUpperCase();
                doUpper = false;
            } else {
                out += ch.toLowerCase();
            }

            if (ch == ' ') {
                doUpper = true;
            }
        }

        return out;
	}

	function indexify(collection, forEachFunc) {
		for (var i = 0; i < collection.length; i++) {
			var item = collection[i];
			item.index = i;
			if (forEachFunc) {
				forEachFunc(item);
			}
		}
	}

	service.setTeacherAppState = function(game, gameState) {
		var exercises = angular.copy(game.exercises);
		indexify(exercises, function(exercise) {
			indexify(exercise.questions, function(question) {
				indexify(question.answers);
			});
			indexify(exercise.evaluationQuestions, function(question) {
				indexify(question.answers);
			});
		});
		service.exercises = exercises;
		service.gameState = gameState;
		service.isTeacher = true;
	}

	service.setInitialState = function(obj) {
		var game = obj.game;
		var gameState = obj.gameState;
		var gameConfig = obj.gameConfig;
		var rides = obj.rides;
		var gameDayInfo = obj.gameDayInfo;

		var exercises = angular.copy(game.exercises);
		indexify(exercises, function(exercise) {
			indexify(exercise.questions, function(question) {
				indexify(question.answers);
			});
			indexify(exercise.evaluationQuestions, function(question) {
				indexify(question.answers);
			});
		});
		service.exercises = exercises;

		service.teamName = game.teamName;
		service.teamMembers = game.teamMembers;

		var year = parseInt(gameDayInfo.startDayYMD.substr(0, 4), 10);
		var month = parseInt(gameDayInfo.startDayYMD.substr(4, 2), 10);
		var day = parseInt(gameDayInfo.startDayYMD.substr(6, 2), 10);

		service.startTime = new Date(year, month - 1, day, 8, 0, 0, 0);

		service.gameState = gameState;
		service.config = gameConfig;
		service.rides = rides;
		service.gameDayInfo = gameDayInfo;

		service.ready = true;
	}

	service.exerciseWithIndex = function(exerciseIndex) {
		for (var i = 0; i < service.exercises.length; i++) {
			var exercise = service.exercises[i];
			if (exercise.index === exerciseIndex) {
				return exercise;
			}
		}
		return undefined;
	}

	service.lookupQuestion = function(exerciseIndex, questionIndex) {
		var exercise = service.exerciseWithIndex(exerciseIndex);
		for (var i = 0; i < exercise.questions.length; i++) {
			var question = exercise.questions[i];
			if (question.index === questionIndex) {
				return question;
			}
		}
		return undefined;
	}

	service.lookupEvaluationQuestion = function(exerciseIndex, evaluationQuestionIndex) {
		var exercise = service.exerciseWithIndex(exerciseIndex);
		for (var i = 0; i < exercise.evaluationQuestions.length; i++) {
			var question = exercise.evaluationQuestions[i];
			if (question.index === evaluationQuestionIndex) {
				return question;
			}
		}
		return undefined;
	}

	service.setTeamInfo = function(obj) {
		return $q(function(resolve, reject) {
			service.teamName = service.titleCaseTeamName(obj.teamName);
			service.teamImageURL = obj.teamImageURL;

			var data = {
				teamName: service.teamName,
				teamImageURL: service.teamImageURL
			};
			$http.post('/api/game/teaminfo', data).then(function() {
				resolve();
			}).catch(function() {
				reject();
			})
		});
	}

	service.setPushToken = function(token) {
		return $q(function(resolve, reject) {
			var data = {
				pushToken: token
			};
			$http.post('/api/game/pushtoken', data).then(function() {
				resolve();
			}).catch(function() {
				reject();
			})
		});
	}

	service.uploadTeamImage = function(fileObj) {
		return $q(function(resolve, reject) {
			$timeout(function() {
				var url = window.FD.BlobToDataURL(fileObj);
				service.teamImageURL = url;
				resolve(url);
			}, 1000);
		});
	}

	service.setWelcomeFinished = function(finished) {
		return $q(function(resolve, reject) {
			service.gameState.finishedWelcome = finished;
			$http.put('/api/game/gamestate', service.gameState).then(function() {
				resolve(true);
			}, function() {
				resolve(false);
			}).catch(function() {
				resolve(false);
			});
		});
		service.gameState.finishedWelcome = finished;
	}

	service.setGameState = function(newState) {
		return $q(function(resolve, reject) {
			service.gameState = JSON.parse(JSON.stringify(newState));

			// Don't post updated state to the service.
			if (service.isTeacher) {
				resolve(true);
				return;
			}

			$http.put('/api/game/gamestate', service.gameState).then(function() {
				resolve(true);
			});
		});
	}

	service.getGameState = function() {
		return JSON.parse(JSON.stringify(service.gameState));
	}

	service.isWelcomeNotFinished = function() {
		return !service.gameState.finishedWelcome;
	}

	service.isGameDone = function() {
		if (service.gameState.exerciseIndex >= service.exercises.length) {
			return true;
		}
		return false;
	}

	service.resetGameState = function() {
		return $q(function(resolve, reject) {
			var cleanSlate = {
				finishedWelcome: false,
				exerciseIndex: 0,
				questionIndex: 0,
				evaluationQuestionIndex: 0,
				score: 0
			};
			service.setGameState(cleanSlate).then(function() {
				resolve(true);
			}, function() {
				reject();
			});
		});
	}

	return service;
}]);
